<template>
  <section class="admin-content" id="contact-search">
    <Navbar />

    <main class="admin-main">
      <div class="bg-dark">
        <div class="container m-b-30">
          <div class="row">
            <div class="col-12 text-white p-t-40 p-b-90">
              <h4 class="">
                <span class="btn btn-white-translucent">
                  <i class="mdi mdi-table"></i
                ></span>
                Disabled Data
              </h4>
              <p class="opacity-75">
                With this tool, we can see all disabled data
              </p>
              <hr />
              <br />

              <form @submit.prevent="getUsers" method="post">
                <div class="form-group">
                  <label class="label">Select Sector</label>
                  <select class="form-control" v-model="selectedSector">
                    <option value="Basic Healthcare Provision Fund">
                      Basic Healthcare Provision Fund
                    </option>
                    <option value="Vulnerable Groups">Vulnerable Groups</option>
                    <option value="Voluntary Contributor">
                      Voluntary Contributor
                    </option>
                    <option value="Organized Community Healthcare Plan">
                      Organized Community Healthcare Plan
                    </option>
                    <option value="State Civil Servant Healthcare Plan">
                      State Civil Servant Healthcare Plan
                    </option>
                    <option value="LGA Civil Servant Healthcare Plan">
                      LGA Civil Servant Healthcare Plan
                    </option>
                    <option
                      value="Universal Basic Education Board Healthcare Plan"
                    >
                      Universal Basic Education Board Healthcare Plan
                    </option>
                    <option value="State Pensioneers Healthcare Plan">
                      State Pensioneers Healthcare Plan
                    </option>
                    <option value="LGA Pensioneers Healthcare Plan">
                      LGA Pensioneers Healthcare Plan
                    </option>
                    <option value="Oganized Private Sector Plan">
                      Organized Private Sector Plan
                    </option>
                    <option value="T-SHIP">
                      Tertiary Student Health Insurance Plan (T-SHIP)
                    </option>
                  </select>
                  <br />
                  <button type="submit" class="btn btn-warning">GET DATA</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="container pull-up">
        <div class="row">
          <div class="col-md-12">
            <div class="card m-b-30">
              <div class="card-header">
                <h5 class="m-b-0">
                  <i class="mdi mdi-checkbox-intermediate"></i> Data Info
                </h5>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>Avatar</th>
                        <th>FUll Name</th>
                        <th>LGA/Ward</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="user in users" v-bind:key="user.id">
                        <td>
                          <div class="avatar avatar-sm" v-if="user.user_image">
                            <img
                              :src="`https://claimify-api.hayokmedicare.ng/image/${user.user_image}`"
                              class="avatar-img avatar-sm rounded-circle"
                              alt=""
                            />
                          </div>
                          <div v-else>
                            <avatar
                              :username="user.firstname + ' ' + user.lastname"
                            ></avatar>
                          </div>
                        </td>
                        <td>{{ user.firstname }} {{ user.lastname }}</td>
                        <td>{{ user.local_name }} {{ user.ward_name }}</td>
                        <!-- <td>{{ user.additionalUsers }}</td> -->
                        <td>
                          <button
                            class="btn btn-danger"
                            @click="disableUser(user.id)"
                            v-if="user.enabled_user == 1"
                          >
                            Disable User
                          </button>
                          <button
                            class="btn btn-success"
                            @click="enableUser(user.id)"
                            v-else-if="user.enabled_user == 0"
                          >
                            Enable User
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
export default {
  components: {
    Navbar,
  },
  data() {
    return {
      isLoading: false,
      users: [],
      selectedSector: "",
      seen: true,
    };
  },
  methods: {
    getUsers() {
      this.axios
        .get(`/api/v1/auth/cleaner/90/` + this.selectedSector)
        .then((response) => {
          this.users = response.data.data;
          console.log("this.users ", this.users);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    disableUser(user_id) {
      //   alert(user_id);
      this.axios
        .post(`/api/v1/auth/disableUser/` + user_id)
        .then(() => {
          alert("User disabled");
          this.getUsers();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    enableUser(user_id) {
      //   alert(user_id);
      this.axios
        .post(`/api/v1/auth/enableUser/` + user_id)
        .then(() => {
          alert("User enabled");
          this.getUsers();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style></style>
